<template>
    <!-- 右边主体[[ -->
	<div class="g-content radar radar-words-analysis g-autofixheight">
        <!-- <div class="radar-main"> -->
        	<!-- <div class="g-laboratory-tabs"> -->
        		<!--热点雷达tab切换点击区域[[-->
        		<div class="f-clearfix g-laboratory-padding laboratory-tabs-wrap">
        			<div class="f-fl g-tab laboratory-tabs-items">
				        <router-link class="g-tab-item" active-class="g-tab-item-active" :to="{name: 'v4-laboratory-radar-trend'}">内容趋势</router-link>
				        <router-link class="g-tab-item" active-class="g-tab-item-active" :to="{name: 'v4-laboratory-radar-word'}">热点词汇</router-link>
				        <router-link class="g-tab-item" active-class="g-tab-item-active" :to="{name: 'v4-laboratory-radar-video'}">热门视频</router-link>
				    </div>
        			<a class="f-fr source-link" href="//fsight.qq.com/" target="_blank">该数据由企鹅风讯提供</a>
        		</div>
        		<!--热点雷达tab切换点击区域]]-->
        		<router-view></router-view>
        	<!-- </div> -->
        <!-- </div> -->
  	</div>
	<!-- 右边主体]] -->
</template>
<style lang="scss" scoped>
    @import  '~Assets/sass/pages/v4/laboratory/radar.scss';
</style>
<script>
export default {
    data() {
        return {}
    },
    components: {},
    mounted(){

    },
    methods: {}
}
</script>
